"use strict";

var _classCallCheck = require("/root/aiga-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/aiga-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This factory aims to create a typed object for a given data (Array, or object), and model
 *
 * @author: Maamar Yacine MEDDAH <my.meddah@gmail.com>
 */

var TypedFactory =
/*#__PURE__*/
function () {
  function TypedFactory() {
    _classCallCheck(this, TypedFactory);
  }

  _createClass(TypedFactory, null, [{
    key: "create",

    /**
     * Takes a data, and model. Returns a typed object
     * @param data: any
     * @param model: Type<T>
     * @returns {T | T[]}
     */
    value: function create(data, model) {
      if (data === undefined || data === null) {
        return data;
      }

      if (Array.isArray(data)) {
        var response = [];

        for (var i = 0; i < data.length; i++) {
          response.push(new model(data[i]));
        }

        return response;
      }

      return new model(data);
    }
  }]);

  return TypedFactory;
}();

exports.TypedFactory = TypedFactory;